<template>
    <div class="shareDetail">
        <p>{{timeFormat(newsInformation.add_time)}} &nbsp; &nbsp; &nbsp; &nbsp;   浏览次数：{{newsInformation.click}}</p>
        <div class="newsDetailContent">{{newsInformation.description}}</div>
            <ul class="share-img-flex" v-if="newsInformation.image_url.length>0">
                <li v-for="(n,i) in newsInformation.image_url" :key="i"><img :src="weburl+n" alt=""  preview="1"></li>
            </ul>

    </div>
</template>

<script>
export default {
  name: "shareDetail",
  data() {
    return {
      newsInformation: {
        image_url: []
      }
    };
  },
  created() {
    this.getDetailInfo(this.$route.params.id);
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "footerNav[6]");
  },
  inject: ["showMsg"],
  methods: {
    getDetailInfo(id) {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "/home/Other/getInfos",
        dataType: "json",
        data: { id: id }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.newsInformation = res.data.result;
            this.$previewRefresh();
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    replaceHtml(text) {
      var txt = "";
      txt = this.htmlDecode(text).replace(
        /src="\/public/g,
        'src="' + this.weburl + "/public"
      );
      return txt;
    },
    timeFormat(timer) {
      var t_html = "";
      var time = new Date(timer * 1000);
      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      var date = time.getDate();
      t_html +=
        "【" + year + "-" + this.Timer(month) + "-" + this.Timer(date) + "】";
      return t_html;
    },
    Timer(m) {
      var time = "";
      time = m < 10 ? "0" + m : m;
      return time;
    }
  },
  computed: {
    //计算属性，
    weburl() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common";
.shareDetail {
  width: @width;
  .box-sizing;
  .media;
  padding: 20px 15px;
  & > p {
    margin-bottom: 10px;
    font-size: @font - 0.2;
    color: @word;
    padding-bottom: 10px;
    .border-bottom;
  }
}
.newsDetailContent {
  padding: 10px 0;
}
.share-img-flex {
  display: flex;
  flex-wrap: wrap;
  li {
    width: 80px;
    margin-right: 5px;
    height: 80px;
    margin-bottom: 5px;
    img {
      width: 100%;
      height: 100%;
    }
    @media (min-width: 760px) {
      width: 150px;
      height: 150px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    @media (max-width: 360px) {
      width: 74px;
      height: 74px;
    }
    @media (max-width: 320px) {
      width: 65px;
      height: 65px;
    }
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}
</style>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
